import { c } from 'react-compiler-runtime';
import { Header } from './Header.js';
import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * Collects related `Items` in an `ActionList`.
 */
function Group(t0) {
  const $ = c(10);
  let header;
  let items;
  let props;
  if ($[0] !== t0) {
    ({
      header,
      items,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = header;
    $[2] = items;
    $[3] = props;
  } else {
    header = $[1];
    items = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== header) {
    t1 = header && /*#__PURE__*/jsx(Header, {
      ...header
    });
    $[4] = header;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== items || $[7] !== props || $[8] !== t1) {
    t2 = /*#__PURE__*/jsxs("div", {
      ...props,
      children: [t1, items]
    });
    $[6] = items;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}

export { Group };
